import { capitalize } from 'vue';

import formatNumber from '@/utils/NumberFormatter';

export default {
  after: (field, [target]) => `The ${capitalize(field)} field must be after ${target}.`,
  after_or_equal: (field, [target]) => `The ${capitalize(field)} field must be after or equal to ${target}.`,
  alpha_dash: (field) =>
    `The ${capitalize(field)} field may contain alpha-numeric characters as well as dashes and underscores.`,
  alpha_num: (field) => `The ${capitalize(field)} field may only contain alpha-numeric characters.`,
  alpha_spaces: (field) => `The ${capitalize(field)} field may only contain alphabetic characters as well as spaces.`,
  alpha: (field) => `The ${capitalize(field)} field may only contain alphabetic characters.`,
  before: (field, [target]) => `The ${capitalize(field)} field must be before ${target}.`,
  before_or_equal: (field, [target]) => `The ${capitalize(field)} field must be before or equal to ${target}.`,
  between: (field, [min, max]) => `The ${capitalize(field)} field must be between ${min} and ${max}.`,
  boolean: (field) => `The value ${capitalize(field)} field is not a valid boolean value`,
  confirmed: (field) => `The ${capitalize(field)} field confirmation does not match.`,
  credit_card: (field) => `The ${capitalize(field)} field is invalid.`,
  date_between: (field, [min, max]) => `The ${capitalize(field)} field must be between ${min} and ${max}.`,
  date_format: (field, [format]) => `The ${capitalize(field)} field must be in the format ${format}.`,
  date_time: (field) => `The ${capitalize(field)} field is not a valid date.`,
  decimal: (field, [decimals] = ['*']) =>
    `The ${capitalize(field)} field must be numeric and may contain ${decimals === '*' ? '' : decimals} decimal points.`,
  digits: (field, [length]) => `The ${capitalize(field)} field must be numeric and exactly contain ${length} digits.`,
  dimensions: (field, [width, height]) => `The ${capitalize(field)} field must be ${width} pixels by ${height} pixels.`,
  domain: (field) =>
    `the ${capitalize(field)} field is not a valid domain, here are some examples: apple.com, coca-cola.com, google.com`,
  email: (field) => `The ${capitalize(field)} field must be a valid email.`,
  ext: (field) => `The ${capitalize(field)} field must be a valid file.`,
  greater_than: (field, min) => `The ${capitalize(field)} field must be greater than ${formatNumber(min, '0,0')}.`,
  image: (field) => `The ${capitalize(field)} field must be an image.`,
  in: (field) => `The ${capitalize(field)} field must be a valid value.`,
  ip: (field) => `The ${capitalize(field)} field must be a valid ip address.`,
  less_than: (field, max) => `The ${capitalize(field)} field must be less than ${formatNumber(max, '0,0')}.`,
  max: (field, [length]) => `The ${capitalize(field)} field may not be greater than ${length} characters.`,
  max_value: (field, max, format) => `The ${capitalize(field)} field must be ${formatNumber(max, format)} or less.`,
  mimes: (field) => `The ${capitalize(field)} field must have a valid file type.`,
  min: (field, [length]) => `The ${capitalize(field)} field must be at least ${length} characters.`,
  min_value: (field, min, format) => `The ${capitalize(field)} field must be ${formatNumber(min, format)} or more.`,
  not_empty: (field) => `${capitalize(field)} field must not be empty.`,
  not_empty_or_whitespace: (field) => `${capitalize(field)} field must not be empty.`,
  not_in: (field) => `The ${capitalize(field)} field must be a valid value.`,
  not_in_use: (field) => `The ${capitalize(field)} field is already in use.`,
  numeric: (field) => `The ${capitalize(field)} field may only contain numeric characters.`,
  regex: (field) => `The ${capitalize(field)} field format is invalid.`,
  required: (field) => `The ${capitalize(field)} field is required.`,
  required_or: (field, [target]) => `Either ${capitalize(field)} field or ${target} is required.`,
  requiredPlural: (field) => `${capitalize(field)} field are required.`,
  size: (field, [size]) => `The ${capitalize(field)} field must be less than ${size} KB.`,
  url: (field) => `The ${capitalize(field)} field is not a valid URL.`,
  url_with_macros: (field) => `The ${capitalize(field)} field is not a valid URL.`,
  uuid: (field) => `${field} is not a valid UUID`,
  string_equals: () => 'Values are not equal',
  password: () => 'Password is too weak',
};
